import { useMemo } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { map, sumBy, isEmpty } from "lodash"
import pluralize from "pluralize"
import { makeCurrencyFormatter } from "helpers/formatters/numbers"
import { Toolbar, Typography, FormControl, IconButton, Input, InputAdornment } from "@mui/material"
import Tooltip from "components/material/tooltip"
import SearchIcon from "@mui/icons-material/Search"
import DeleteIcon from "@mui/icons-material/Delete"
import { INSTRUMENT_SIZE_SHAPE } from "modules/smart-trade-panel/helpers"

export default function EnhancedTableToolbar(props) {
  const { items, numSelected, count, selected, removeSecurities, setSelected, setSearch, instrumentSize } = props

  const handleDelete = () => {
    removeSecurities(
      map(selected, (id) => items.find(({ id: itemId }) => id === itemId)),
      () => setSelected([]),
    )
  }
  const basketGMV = useMemo(() => {
    let selectedItems = items
    let baseIntrumentValue = 0
    // Calculate only the selected item values
    if (!isEmpty(selected)) {
      selectedItems = map(selected, (id) => items.find(({ id: itemId }) => id === itemId))
    } else if (instrumentSize) {
      baseIntrumentValue = instrumentSize.dollarValue
    }
    return baseIntrumentValue + sumBy(selectedItems, (item) => Math.abs(item.dollarValue))
  }, [items, selected, instrumentSize])
  const formattedBasketGMV = makeCurrencyFormatter()(basketGMV)

  return (
    <Toolbar className={classnames(["root", "toolbar"], { highlight: numSelected > 0 })}>
      {numSelected > 0 ? (
        <Typography
          className="title"
          variant="subtitle1"
          component="div"
          sx={{
          color: "inherit",
        }}
        >
          {numSelected} {pluralize("security", numSelected)} selected  | {formattedBasketGMV}
        </Typography>
      ) : (
        <Typography className="title" id="tableTitle" component="div">
          {count} {pluralize("security", count)} | {formattedBasketGMV}
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete" onClick={handleDelete} size="large">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <FormControl variant="standard" className="search-box">
          <Input
            id="positions-panel-search"
            placeholder="Search"
            startAdornment={<InputAdornment position="start"><SearchIcon /></InputAdornment>}
            onChange={(e) => setSearch(e.target.value)}
          />
        </FormControl>

      )}
    </Toolbar>
  )
}

EnhancedTableToolbar.propTypes = {
  items: PropTypes.array.isRequired,
  numSelected: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  selected: PropTypes.array,
  removeSecurities: PropTypes.func.isRequired,
  setSelected: PropTypes.func.isRequired,
  setSearch: PropTypes.func.isRequired,
  instrumentSize: PropTypes.oneOfType([PropTypes.bool, INSTRUMENT_SIZE_SHAPE]).isRequired,
}
